import Footer from '../components/Footer'
import React from 'react'

export default function Viewmore() {
  return (
    <div>
        viewMore
    </div>
  )
}
